import ReportCard from "../../components/CardHod/CardHod";
import NavbarDashboard from "../../components/navbarDashboard/NavbarDashboard";
import Searchbar from "../../components/SearchBar/SearchBar";
import * as React from "react";
import { useParams, useNavigate } from "react-router-dom";
import ButtonEditPage from "../../components/ButtonEditPage/ButtonEditPage";
import SectionDisplayCard from "../../components/SectionDisplayCard/SectionDisplayCard";
import { Stack } from "@mui/material";

function AdministratorEditPage(){
    const { id } = useParams();
    const {currentYear} = useParams();
    const {currentQuarter} = useParams();

    const cardData = [
        {
          title: "Staff (Grant in aid)",
          content:
            "",
        },
        {
          title: "Staff (Self supporting)",
          content:
            "",
        },
        {
          title: "AICTE Approval",
          content:
            "",
        },
        {
          title: "AU Affiliation",
          content:
            "",
        },
        {
          title: "Report",
          content:
            "",
        },
      ];
      const navigate = useNavigate();
      const handleClick = (title) => {
        const encodedTitle = encodeURIComponent(title);
        navigate(`/administratorQuillEdit/${id}/${currentYear}/${currentQuarter}/${encodedTitle}`);
      };
    
      return (
        <div>
          <NavbarDashboard />
          {/* <ButtonEditPage
            title="Progress"
            style={{ marginLeft: "5%", marginTop: "7%" }}
          /> */}
          <div className="grid-container" style={{ marginTop: "5%" }}>
            {cardData.map((card, index) => (
              <SectionDisplayCard
                key={index}
                title={card.title}
                content={card.content}
                //onClickCard={handleClick}
                onClickCard={() => handleClick(card.title)}
              />
            ))}
          </div>
          <div  style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "20px",
              }}>
              <ButtonEditPage title="Submit" />
              {/* <ButtonEditPage title="Submit" /> */}
          </div>
        </div>
      );
}

export default AdministratorEditPage;